<template>
    <div id="hero">
        <el-main class="hero-section">
            <el-row align="middle" justify="center">
                <el-col :span="824">
                    <h2>欢迎来到德思贤</h2>
                    <p>
                        整合德思贤科技机电研发能量，汇聚院内不同领域的技术人才，为未来革命性、前瞻性的创新技术进行市场调研、开发设计和分析。
                    </p>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script setup>

</script>

<style scoped>
.hero-section {
    background-color: #f5f5f5;
    padding: 50px 0;
    text-align: center;
}

.hero-section h1 {
    font-size: 36px;
    margin-bottom: 20px;
}

.hero-section p {
    font-size: 18px;
    color: #666;
}
</style>